require("./src/sdk");
import { isInitializedBefore, onLoaded, onTabVisible } from "./src/sdk";
import log2 from "./js/log2-lite";
import CONFIG from "./src/config";
import { checkViewPort, fetchSiteData, fetchSiteSetting, onDocReady } from "./src/utils";
import { getBubble } from "./src/bubbles";

const log = log2("Loader");

function start() {
    window.supsisLoadingStarted = true;
    let siteSettings;
    try {
        siteSettings = JSON.parse(localStorage.getItem("settings")) || null;
    } catch (e) {
        localStorage.removeItem("settings");
    }

    if (Array.isArray(siteSettings)) siteSettings = siteSettings[0];
    let siteData = null;

    fetchSiteData().then((site) => {
        if (site && site._id) {
            siteData = site;
            window.siteData = siteData;
            log.debug("site data fetched");
            fetchSiteSetting(site._id).then((settings) => {
                log("site settings fetched", settings);
                let isIdeasoft = !!siteData.partner && !!siteData.partner.name && siteData.partner.name === "ideasoft";
                onDocReady().then(() => {
                    // Bu yalnızca idea softtan gelen müşteriler için yapıldı. chat balonunu (istedikleri zaman) login olmayan visitore gizleyebiliyorlar.
                    if (isIdeasoft && settings[0].showChatBubbleOnlyLoggedUser && window["isMember"] === 0) return;
                    const isHidden = settings[0].visibilityConfig && settings[0].visibilityConfig.forceHide;
                    if (settings[0].visibilityConfig && settings[0].visibilityConfig.forceHide) {
                        log.warn(
                            `supsis chat widget switched to force hide mode due to ${settings[0].visibilityConfig.forceHideReason}`
                        );
                    }
                    const ls = new SupSis(settings[0], isHidden);
                    ls.init();
                    window.supsis.i = ls;
                    window.supsis.i.liveTraffic =
                        settings[0].liveTraffic || window.localStorage.getItem("supsis-opened") === "true";
                    if (
                        ["tr.uspoloassn.com", "www.pierrecardin.com.tr", "www.cacharel.com.tr"].includes(
                            window.location.host
                        )
                    ) {
                        window.supsis.i.liveTraffic = false;
                    }

                    checkViewPort();
                    if (window.supsis.i.liveTraffic) {
                        window.supsis.i.iframeLoad();
                    } else {
                        applySettings(settings[0], true);
                        document.body.appendChild(window.supsis.i.openButton);
                    }
                });
                applySettings(settings[0]);
            });
        }
    });

    function createBacklink() {
        onLoaded().then(() => {
            const texts = [
                "Canlı Destek",
                "Live Support",
                "Chatbot",
                "Live Chat",
                "Web Chat",
                "Whatsapp Chat",
                "Chat Balonu",
                "E-ticaret Botu",
                "E-ticaret Chatbotu",
                "E-ticaret Canlı Destek",
                "E-ticaret Live Chat",
                "E-ticaret Whatsapp Chat",
                "E-ticaret Whatsapp Destek",
                "E-ticaret Whatsapp Canlı Destek",
                "Canlı Destek Uygulaması",
                "Canlı Destek Yazılımı",
                "Canlı Destek Sistemi",
                "Canlı Destek Programı",
                "Canlı Destek Yazılımı",
                "Website Chat Bubble",
                "Website Chat",
                "Website Live Chat",
                "Website Live Support",
                "Whatsapp Chatbot",
                "Yapay Zeka Chatbot",
                "Whatsapp Business API",
                "Whatsapp Business Chatbot",
                "AI Otomasyon",
                "Otomasyon Sistemi",
                "AI Chatbot Sistemi",
                "AI CRM",
                "AI Call Center",
                "AI Voice",
                "AI Form Modülü",
                "Form Yönetim Sistemi",
                "Mail Entegrasyonu",
                "AI Mail Entegrasyonu",
                "Ticket Sistemi",
                "Görev Yönetim Modülü",
                "AI Görev Yönetim Modülü",
                "Yapay Zeka Çağrı Merkezi",
                "No-Code Chatbot Sistemi",
                "Dinamik Tablo Sistemi",
                "Yapay Zeka (ChatGPT)",
                "Takvim ve Rezervasyon",
                "Mail Otomasyonu",
                "WhatsApp Business API",
                "Whatsapp Entegrasyonu (QR)",
                "Facebook Entegrasyonu",
                "Instagram Entegrasyonu",
                "Instagram Entegrasyonu AI",
                "Telegram Entegrasyonu",
                "Trendyol Entegrasyonu",
                "LinkedIn Entegrasyonu",
                "Raporlama",
                "Dosya Transferi",
                "Şirket içi İletişim",
                "Sesli ve Görüntülü Arama",
                "Hazır İçerik Sistemi",
                "Her Dilde İletişim",
                "Web Chat Canlı Trafik",
                "Pop-Up (Akıllı) Tetikleyici",
                "Anlık Bildiri Sistemi",
                "Çevrimdışı Mesajlaşma",
                "Balon Özelleştirme",
                "Toplu Mesaj Gönderimi",
                "Sağlık Hizmetleri Çözümleri",
                "Eğitim Çözümleri",
                "Sigorta Çözümleri",
                "E-Ticaret Çözümleri",
                "Emlak Sektörü",
                "Otel Çözümleri",
                "Otomotiv Sektörü",
                "Hukuk Çözümleri",
                "Lojistik Çözümleri",
                "Restoran Çözümleri",
                "AI Entegrasyonları",
                "AI Chatbot Entegrasyonu",
                "Yapay Zeka Tabanlı Çözümler",
                "Canlı Destek Entegrasyonu",
                "E-Ticaret Canlı Destek Entegrasyonu",
                "E-Ticaret AI Chatbot",
                "Sosyal Medya Entegrasyonları",
                "Web Chat Yöntemleri",
                "Canlı Destek API",
                "WhatsApp API Entegrasyonu",
                "Facebook AI Entegrasyonu",
                "Instagram Chatbot Entegrasyonu",
                "Telegram Bot Entegrasyonu",
                "AI Tabanlı Chat Sistemleri",
                "Web ve Mobil Chat Uygulamaları",
                "Akıllı Mesajlaşma Sistemi",
                "Canlı Destek Pop-Up",
                "AI Sesli Yanıt Sistemi",
                "Çevrimdışı Chat Sistemleri",
                "Otomasyonlu Chatbot Sistemi",
                "Veri Tabanlı Canlı Destek",
                "Yapay Zeka Destekli Chat Sistemleri",
                "E-Ticaret İçin AI Çözümleri",
                "Sektöre Özel Chatbot Çözümleri",
                "Restoran Canlı Destek",
                "Sağlık Sektörü Chatbot",
                "Emlak Chatbot",
                "Sigorta Chatbot",
                "Hukuk Chatbot",
                "Otomotiv Chatbot",
                "Lojistik Chatbot",
                "E-Ticaret Chatbot",
                "Yapay Zeka ile Anlık Mesajlaşma",
                "E-Ticaret için Mail Entegrasyonu",
                "Canlı Destek Mail Sistemi",
                "WhatsApp Business Chat Entegrasyonu",
                "AI Ticketing Sistemi",
                "Yapay Zeka İletişim Sistemleri",
                "Sosyal Medya İletişim Sistemleri",
            ];

            const urls = {
                "Canlı Destek": "https://supsis.com/tr/canli-destek/",
                "Live Support": "https://supsis.com/tr/canli-destek/",
                Chatbot: "https://supsis.com/tr/chatbot/",
                "Live Chat": "https://supsis.com/tr/canli-destek/",
                "Web Chat": "https://supsis.com/tr/canli-destek/",
                "Whatsapp Chat": "https://supsis.com/tr/whatsapp-entegrasyonu/",
                "Chat Balonu": "https://supsis.com/tr/canli-destek/",
                "E-ticaret Botu": "https://supsis.com/tr/otomasyon-sistemi/",
                "E-ticaret Chatbotu": "https://supsis.com/tr/chatbot/",
                "E-ticaret Canlı Destek": "https://supsis.com/tr/canli-destek/",
                "Yapay Zeka Chatbot": "https://supsis.com/tr/yapay-zeka-chat-gpt/",
                "Whatsapp Business API": "https://supsis.com/tr/whatsapp-business-api-entegrasyonu/",
                "Whatsapp Business Chatbot": "https://supsis.com/tr/whatsapp-business-api-entegrasyonu/",
                "AI Otomasyon": "https://supsis.com/tr/otomasyon-sistemi/",
                "Otomasyon Sistemi": "https://supsis.com/tr/otomasyon-sistemi/",
                "AI Chatbot Sistemi": "https://supsis.com/tr/chatbot/",
                "AI CRM": "https://supsis.com/tr/otomasyon-sistemi/",
                "AI Call Center": "https://supsis.com/tr/yapay-zeka-call-center/",
                "AI Voice": "https://supsis.com/tr/yapay-zeka-call-center/",
                "AI Form Modülü": "https://supsis.com/tr/form-yonetimi/",
                "Form Yönetim Sistemi": "https://supsis.com/tr/form-yonetimi/",
                "Mail Entegrasyonu": "https://supsis.com/tr/gelismis-toplu-e-posta-servisi/",
                "AI Mail Entegrasyonu": "https://supsis.com/tr/gelismis-toplu-e-posta-servisi/",
                "Ticket Sistemi": "https://supsis.com/tr/canli-destek/",
                "Görev Yönetim Modülü": "https://supsis.com/tr/otomasyon-sistemi/",
                "Yapay Zeka Çağrı Merkezi": "https://supsis.com/tr/yapay-zeka-call-center/",
                "No-Code Chatbot Sistemi": "https://supsis.com/tr/chatbot/",
                "Dinamik Tablo Sistemi": "https://supsis.com/tr/tablolar/",
                "Yapay Zeka (ChatGPT)": "https://supsis.com/tr/yapay-zeka-chat-gpt/",
                "Takvim ve Rezervasyon": "https://supsis.com/tr/takvim-modulu/",
                "Mail Otomasyonu": "https://supsis.com/tr/gelismis-toplu-e-posta-servisi/",
                "WhatsApp Business API": "https://supsis.com/tr/whatsapp-business-api-entegrasyonu/",
                "Facebook Entegrasyonu": "https://supsis.com/tr/facebook-entegrasyonu/",
                "Instagram Entegrasyonu": "https://supsis.com/tr/instagram-entegrasyonu/",
                "Telegram Entegrasyonu": "https://supsis.com/tr/telegram-entegrasyonu/",
                "Trendyol Entegrasyonu": "https://supsis.com/tr/trendyol-ai/",
                "LinkedIn Entegrasyonu": "https://supsis.com/tr/linkedin-entegrasyonu/",
            };

            const backlinkElement = document.createElement("a");

            const selectedText = texts[Math.floor(Math.random() * texts.length)];

            let selectedUrl = urls[selectedText] || "https://supsis.com/tr/";

            backlinkElement.href = selectedUrl;
            backlinkElement.target = "_blank";
            backlinkElement.rel = "dofollow";
            backlinkElement.innerText = selectedText;
            backlinkElement.style.display = "none";

            window.document.body.appendChild(backlinkElement);
        });
    }

    const applySettings = (settings, forceApply = false) => {
        log("applySettings", settings);
        siteSettings = settings;
        localStorage.setItem("settings", JSON.stringify(settings));
        const waitLoad = forceApply ? Promise.resolve() : onLoaded();
        waitLoad.then(() => {
            if (!!settings && !!settings.bubble) {
                let { preDefined, customIcon, bubbleColor, heightOfBubble } = settings.bubble;
                let cHeight = !!settings.bubble.heightOfBubble ? settings.bubble.heightOfBubble + "px" : "60px";
                log("bubble settings", { preDefined, customIcon, bubbleColor, heightOfBubble });
                if (preDefined === "0" && !!customIcon) {
                    const asset = customIcon;
                    const oldPath = `https://static.supsis.live/${asset.path}${asset.id}.${asset.ext}`;
                    window.supsis.i.openButton.innerHTML = `<div style="height:${cHeight};justify-content: flex-end;"><img src="${
                        asset.v2Format && asset.cdnUrl ? asset.cdnUrl : oldPath
                    }">
                        </div>`;
                } else if (getBubble(preDefined, bubbleColor).img) {
                    log("getBubble()", getBubble(preDefined, bubbleColor));
                    const navigatorLanguage = navigator.language.split("-")[0];
                    let visitorLanguage = settings.language.customerClientDefault || navigatorLanguage;
                    if (visitorLanguage == "ar") visitorLanguage = "ar";

                    if (
                        settings.chatCustomizationSettings &&
                        settings.chatCustomizationSettings.langContentOfBubbleMessage &&
                        Object.keys(settings.chatCustomizationSettings.langContentOfBubbleMessage).length > 0 &&
                        (getBubble(preDefined, bubbleColor).indexOfImg === "7" ||
                            getBubble(preDefined, bubbleColor).indexOfImg === "8")
                    ) {
                        if (
                            (!!settings &&
                                !!settings.chatCustomizationSettings &&
                                !!settings.chatCustomizationSettings.position &&
                                settings.chatCustomizationSettings.position === "right") ||
                            settings.chatCustomizationSettings.position === "bottomRight"
                        ) {
                            window.supsis.i.openButton.innerHTML = `
                        <div class="d-flex">
                            <div class="d-flex align-items-center justify-content-center"
                             style="height:${cHeight};justify-content: flex-end;display: inline-block;position: relative">${
                                getBubble(preDefined, bubbleColor).img
                            }
                            </div>
                            <div class="d-flex justify-content-center align-items-center flex-column" >
                                <div class="d-flex justify-content-center align-items-center"  style="position: absolute; height: 60%; text-align: center; width: ${
                                    parseInt(cHeight.slice(0, -2)) * 2 + "px"
                                }; margin: auto; top: 0; bottom: 0; right: 0; left: ${cHeight}; font-size: 12px;">
                                <p style="margin-top:unset;margin-bottom: unset ">${
                                    settings.chatCustomizationSettings.langContentOfBubbleMessage[visitorLanguage]
                                } </p>
                                </div>
                            </div>
                        </div> `;
                        } else {
                            window.supsis.i.openButton.innerHTML = `
                        <div class="d-flex">
                            <div class="d-flex align-items-center justify-content-center"
                             style="height:${cHeight};justify-content: flex-end;display: inline-block;position: relative">${
                                getBubble(preDefined, bubbleColor).img
                            }
                            </div>
                            <div class="d-flex justify-content-center align-items-center flex-column" >
                                <div class="d-flex justify-content-center align-items-center"  style="position: absolute; height: 60%; text-align: center; width: ${
                                    parseInt(cHeight.slice(0, -2)) * 2 + "px"
                                }; margin: auto; top: 0; bottom: 0; right: 0; left: ${
                                (parseInt(cHeight.slice(0, -2)) * 4) / 3 + "px"
                            }; font-size: 12px;">
                                <p style="margin-top:unset;margin-bottom: unset ">${
                                    settings.chatCustomizationSettings.langContentOfBubbleMessage[visitorLanguage]
                                } </p>
                                </div>
                            </div>
                        </div> `;
                        }
                    } else {
                        window.supsis.i.openButton.innerHTML = `<div style="height:${cHeight};justify-content: flex-end;">${
                            getBubble(preDefined, bubbleColor).img
                        }</div>`;
                    }
                } else {
                    window.supsis.i.openButton.innerHTML =
                        '<img src="' + CONFIG.BASE_URL + 'static/img/newLogo.png"  alt=""/>';
                }
            } else {
                window.supsis.i.openButton.innerHTML = `<img src="${CONFIG.BASE_URL}static/img/newLogo.png" alt="">`;
            }

            if (!!settings) {
                const chatCustomizationSettings = settings.chatCustomizationSettings;
                const isMobile = window.outerWidth < 1083;
                const openButtonHPos = () => {
                    let marginX = chatCustomizationSettings.margin.x;
                    if (isMobile) {
                        if (
                            chatCustomizationSettings.overrideMobileMargin &&
                            !isNaN(chatCustomizationSettings.mobileMargin.x)
                        ) {
                            marginX = chatCustomizationSettings.mobileMargin.x;
                        }
                    }
                    return marginX <= window.innerWidth ? marginX + "px" : window.innerWidth - 70 + "px";
                };
                const openButtonVPos = () => {
                    let marginY = chatCustomizationSettings.margin.y;
                    if (isMobile) {
                        if (
                            chatCustomizationSettings.overrideMobileMargin &&
                            !isNaN(chatCustomizationSettings.mobileMargin.y)
                        ) {
                            marginY = chatCustomizationSettings.mobileMargin.y;
                        }
                    }
                    return marginY <= window.innerHeight ? marginY + "px" : window.innerHeight - 70 + "px";
                };
                const marginX = chatCustomizationSettings.margin.x;
                const mobileMarginX =
                    chatCustomizationSettings.overrideMobileMargin &&
                    !!chatCustomizationSettings.mobileMargin &&
                    isMobile
                        ? chatCustomizationSettings.mobileMargin.x
                        : undefined;
                const marginY = chatCustomizationSettings.margin.y;
                const mobileMarginY =
                    chatCustomizationSettings.overrideMobileMargin &&
                    !!chatCustomizationSettings.mobileMargin &&
                    isMobile
                        ? chatCustomizationSettings.mobileMargin.y
                        : undefined;

                if (chatCustomizationSettings.position === "bottomLeft") {
                    window.supsis.i.openButton.style.left = "10px";
                    window.supsis.i.container.style.left = "0px";

                    if (!!marginX || !!mobileMarginX) {
                        window.supsis.i.openButton.style.left = openButtonHPos();
                        log("settings case bottom left if x", window.supsis.i.openButton.style.left);
                    } else {
                        window.supsis.i.openButton.style.left = "10px";
                        log("settings var else girdi deafult 10");
                    }
                    if (!!marginY || !!mobileMarginY) {
                        window.supsis.i.openButton.style.bottom = openButtonVPos();
                        log("settings case bottom left if y", window.supsis.i.openButton.style.left);
                    } else window.supsis.i.openButton.style.bottom = "10px";
                } else if (chatCustomizationSettings.position === "left") {
                    window.supsis.i.openButton.style.left = "10px";
                    window.supsis.i.container.style.left = "0px";
                    window.supsis.i.container.style.top = "0";
                    window.supsis.i.container.style.height = "calc(100%)";
                    if (!!marginX || !!mobileMarginX) {
                        window.supsis.i.openButton.style.left = openButtonHPos();
                    } else window.supsis.i.openButton.style.left = "10px";
                    if (!!marginY || !!mobileMarginY) {
                        window.supsis.i.openButton.style.bottom = openButtonVPos();
                    } else window.supsis.i.openButton.style.bottom = "10px";
                } else if (chatCustomizationSettings.position === "bottomRight") {
                    window.supsis.i.openButton.style.right = "10px";
                    window.supsis.i.container.style.right = "0px";
                    window.supsis.i.openButton.style.width = "auto";
                    if (!!marginX || !!mobileMarginX) {
                        window.supsis.i.openButton.style.right = openButtonHPos();
                    } else window.supsis.i.openButton.style.right = "10px";
                    if (!!marginY || !!mobileMarginY) {
                        window.supsis.i.openButton.style.bottom = openButtonVPos();
                    } else window.supsis.i.openButton.style.bottom = "10px";
                } else if (chatCustomizationSettings.position === "right") {
                    window.supsis.i.openButton.style.right = "10px";
                    window.supsis.i.container.style.right = "0px";
                    window.supsis.i.container.style.top = "0";
                    window.supsis.i.container.style.height = "calc(100%)";
                    window.supsis.i.openButton.style.width = "auto";
                    if (!!marginX || !!mobileMarginX) {
                        window.supsis.i.openButton.style.right = openButtonHPos();
                    } else window.supsis.i.openButton.style.right = "10px";
                    if (!!marginY || !!mobileMarginY) {
                        window.supsis.i.openButton.style.bottom = openButtonVPos();
                    } else window.supsis.i.openButton.style.bottom = "10px";
                } else {
                    window.supsis.i.openButton.style.left = "10px";
                    window.supsis.i.openButton.style.bottom = "10px";
                    window.supsis.i.container.style.left = "0px";
                }

                if (
                    !!chatCustomizationSettings.preferredAnimation &&
                    chatCustomizationSettings.preferredAnimation !== "No Animation"
                ) {
                    if (chatCustomizationSettings.preferredAnimation === "flash") {
                        window.supsis.i.openButton.style.animation = `2.5s ls-${chatCustomizationSettings.preferredAnimation} infinite linear `;
                    } else if (chatCustomizationSettings.preferredAnimation === "flip")
                        window.supsis.i.openButton.style.animation = `6s ls-${chatCustomizationSettings.preferredAnimation} infinite linear `;
                    else if (
                        chatCustomizationSettings.preferredAnimation === "bounce" ||
                        chatCustomizationSettings.preferredAnimation === "wobble"
                    )
                        window.supsis.i.openButton.style.animation = `3s ls-${chatCustomizationSettings.preferredAnimation} infinite linear `;
                    else
                        window.supsis.i.openButton.style.animation = `2s ls-${chatCustomizationSettings.preferredAnimation} infinite linear `;
                }
            }
            log("applySettings end", { s: siteSettings, a: siteSettings.fab.items, f: settings.fab.items });
            if (
                !!settings &&
                !!settings.fab &&
                !!settings.fab.items &&
                !!settings.fab.isFabsActive &&
                settings.fab.isFabsActive === true
            ) {
                if (
                    (!!settings && !!settings._id && String(settings._id) === "5d46c0270316011b9c9706aa") ||
                    localStorage.fabEnabled === "true" ||
                    true
                )
                    window.supsis.i.fab(window.supsis.i);
            }

            try {
                createBacklink();
            } catch (e) {}
        });
    };

    let SupSis = function (settings, isHidden) {
        log.debug("SupSis init", settings);
        this.baseUrl = CONFIG.BASE_URL;
        this.isHidden = isHidden;
        this.body = document.getElementsByTagName("body")[0];
        this.head = document.getElementsByTagName("head")[0];
        this.cssFile = this.baseUrl + "static/css/supsis.css";
        this.jsFile = this.baseUrl + "static/js/supsis-actions.js";
        this.akinonJSFile = this.baseUrl + "static/js/akinon.js";
        this.akinonCSSFile = this.baseUrl + "static/css/supsis-extra-aydinli.css";
        this.iconUrls = {
            minimize: this.baseUrl + "static/img/minimize.png",
            newTab: this.baseUrl + "static/img/new-tab.png",
            move: this.baseUrl + "static/img/move-icon.png",
        };
        this.container = null;
        this.iframe = null;
        this.badge = !!localStorage.getItem("ls-badge") ? parseInt(localStorage.getItem("ls-badge")) : 0;
        this.badgeElem = null;
        this.openButton = null;
        this.minimizeButton = null;
        this.triangleFooter = null;
        this.window = null;
        this.showFab = false;
        this.isOpen = () => document.body.classList.contains("ls-opened");
        this.settings = settings;
        this.triggerElems = {
            askContainer: null,
            container: null,
            messageContainer: null,
            close: null,
            question: null,
            title: null,
            showHeaderImage: null,
            popupTireggers: null,
        };
        this.newVersion = !!settings.chatCustomizationSettings ? settings.chatCustomizationSettings.isVersionV2 : false;
        if (this.newVersion) {
            log.warn("visitor v2 version detected");
        }
        this.fabContainer;
    };
    SupSis.prototype.setupV2 = function () {
        const settings = this.settings;
        let visibleWindow = settings.chatCustomizationSettings.versionV2Theme.colors.headerColorFirst;
        const relocateContainer = (triangleFooter, poweredBy) => {
            this.container.style.marginBottom = "60px";
            if (["bottomLeft", "left"].includes(settings.chatCustomizationSettings.position)) {
                if (window.outerWidth > 950) {
                    this.container.style.marginLeft = "30px";
                }
                this.container.style.marginRight = "0px";
                this.container.style.boxShadow = "-2px 2px 4px rgba(0, 0, 0, 0.3)";
                triangleFooter.style.transform = "scaleX(-1)";
                poweredBy.style.transform = "scaleX(-1)";
                poweredBy.style.left = "42px";
                if (["left"].includes(settings.chatCustomizationSettings.position)) {
                    this.container.style.borderRadius = "20px";
                } else {
                    this.container.style.borderRadius = "20px 20px 20px 0px";
                }
            } else {
                if (window.outerWidth > 950) {
                    this.container.style.marginRight = "15px";
                }
                this.container.style.marginLeft = "0px";
                this.container.style.boxShadow = "2px 2px 4px rgba(0, 0, 0, 0.3)";
                if (["right"].includes(settings.chatCustomizationSettings.position)) {
                    this.container.style.borderRadius = "20px";
                } else {
                    this.container.style.borderRadius = "20px 20px 0px 20px";
                }
            }
        };
        if (!this.triangleFooter) {
            this.triangleFooter = document.createElement("div");
            this.triangleFooter.className = "ls-footer";
            const triangleImage = document.createElement("div");
            this.minimizeButton = document.createElement("div");
            const poweredBy = document.createElement("div");
            const powerdByUrl = CONFIG.VISITOR_POWERED_BY_LINK.VATANCOMPUTER;
            const position = settings.chatCustomizationSettings.position;
            if (position === "right" || position === "left") {
                poweredBy.className = "powered-by-right";
                this.triangleFooter.style.zIndex = "9999";
            } else {
                poweredBy.className = "powered-by";
            }
            if (settings.brandVisible) {
                if (powerdByUrl === settings.siteId) {
                    poweredBy.innerHTML = `<img id="PoweredImage" class="powered-image" src="${CONFIG.BASE_URL}static/img/poweredBySupsisRGB.png"  />`;
                } else {
                    poweredBy.innerHTML = `<a href="https://supsis.com/" target="_blank"><img id="PoweredImage" class="powered-image" src="${CONFIG.BASE_URL}static/img/poweredBySupsisRGB.png"  /></a>`;
                }
                const poweredImage = poweredBy.querySelector(".powered-image");

                poweredImage.addEventListener("mouseenter", () => {
                    poweredImage.src = `${CONFIG.BASE_URL}static/img/poweredBySupsis.png`;
                });
                poweredImage.addEventListener("mouseleave", () => {
                    poweredImage.src = `${CONFIG.BASE_URL}static/img/poweredBySupsisRGB.png`;
                });
                // poweredBy.innerHTML = `<a href="https://supsis.com/" target="_blank"><img class="powered-image" src="${CONFIG.BASE_URL}static/img/powerdBY-LOGO.png"  /></a>`;
            }

            triangleImage.className = "triangle-wrapper";
            triangleImage.style.position = "absolute";
            triangleImage.style.right = "0";
            triangleImage.style.top = "0";
            // triangleImage.innerHTML = `<svg class="triangle-svg" width="200" height="200" viewBox="0 0 66 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            // <path d="M0 0L0 0.00502248C31.9915 0.219447 58.6646 7.27657 66 16.7387V0H0Z" fill="${visibleWindow}"></svg>`;
            //
            // const svgDom = triangleImage.querySelector(".triangle-svg");
            // svgDom.style.filter = "drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.3))";

            this.triangleFooter.id = "ls-footer";
            this.triangleFooter.style.right = "0px";

            this.triangleFooter.appendChild(triangleImage);
            this.triangleFooter.appendChild(poweredBy);
            this.container.appendChild(this.triangleFooter);
            this.triangleFooter.appendChild(this.minimizeButton);
            this.minimizeButton.id = "ls-minimize-button";
            this.minimizeButton.innerHTML = `
              <div class="ls-close-container">
                <div class="ls-leftright"></div>
                <div class="ls-rightleft"></div>
              </div>
            `;
            this.minimizeButton.title = "Minimize";
            this.minimizeButton.style.backgroundColor = settings.bubble.bubbleColor;

            relocateContainer(this.triangleFooter, poweredBy);

            this.triangleFooter.changeColor = (color1, color2) => {
                triangleImage.innerHTML = "";
                triangleImage.innerHTML = `<svg class="triangle-svg" width="72" height="52" viewBox="0 0 72 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0C13.2548 0 24 10.7452 24 24V28C24 41.2548 34.7452 52 48 52C61.2548 52 72 41.2548 72 28V0H24H0Z" fill="${color1}"/>
                <rect x="28" y="8" width="40" height="40" rx="20" fill="${color1}"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M55.8836 35.8843C56.3718 35.3961 56.3718 34.6047 55.8836 34.1165L49.7674 28.0001L55.8838 21.8839C56.3719 21.3957 56.3719 20.6043 55.8838 20.1161C55.3956 19.628 54.6042 19.628 54.116 20.1161L47.9997 26.2323L41.8837 20.1161L41.5323 20.4675L41.8837 20.1161C41.3955 19.628 40.604 19.628 40.1159 20.1161C39.6277 20.6043 39.6277 21.3957 40.1159 21.8839L46.2319 28L40.1156 34.1161L40.467 34.4674L40.1156 34.1161C39.6275 34.6043 39.6275 35.3957 40.1156 35.8839C40.6038 36.372 41.3952 36.372 41.8834 35.8839L47.9996 29.7678L54.1159 35.8843C54.604 36.3724 55.3955 36.3724 55.8836 35.8843Z" fill="${color2}"/>
                </svg>`;
                const svgDom = triangleImage.querySelector(".triangle-svg");
                svgDom.style.filter = "drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.3))";
                svgDom.addEventListener("click", () => {
                    supsis("minimize");
                });
            };
        } else {
            log.warn("triangle footer already exists");
            relocateContainer(this.triangleFooter, this.poweredBy);
        }

        document.body.classList.add("ls-v2");
        this.container.classList.add("v2");
        if (settings.chatCustomizationSettings.position === "bottomLeft") {
            this.container.classList.add("bottomLeft");
        }
        this.container.style.backgroundColor = "transparent";
    };
    SupSis.prototype.updateSettings = function (settings) {
        log.debug("updateSettings", settings);
        this.settings = settings;
        this.newVersion = !!settings.chatCustomizationSettings ? settings.chatCustomizationSettings.isVersionV2 : false;
        if (this.newVersion) {
            if (!this.container.classList.contains("v2")) {
                this.setupV2();
            }
        } else {
            if (this.container.classList.contains("v2")) {
                this.container.classList.remove("v2");
                document.body.classList.remove("ls-v2");
                this.container.style.marginLeft = "0px";
                this.container.style.marginRight = "0px";
                this.container.style.marginBottom = "0px";
            }
        }
    };
    SupSis.prototype.init = function () {
        log.debug("init");
        this.requireSystem();
        this.requireAssets();
        this.initWindowConnection();
    };
    SupSis.prototype.initWindowConnection = function () {
        log.debug("initWindowConnection");
        const self = this;
        window.addEventListener("beforeunload", function () {
            log("beforeunload");
            self.iframe.contentWindow.postMessage(
                {
                    command: "host-page-closing",
                    payload: {},
                },
                "*"
            );
            return undefined;
        });
        log("window.onmessage binded");
        window.onmessage = function (e) {
            if (e.data.command) {
                log("a command received", e.data.command, e.data);
                switch (e.data.command) {
                    case "maximize":
                        log("maximize btn clicked");
                        self.minimizeButton.click();
                        self.window = window.open(self.iframe.src, "ls.window");

                        const timer = setInterval(function () {
                            if (self.window && self.window.closed) {
                                self.openButton.click();

                                clearInterval(timer);
                            }
                        }, 500);
                        break;
                    case "minimize":
                        log.debug("minimize btn clicked");
                        self.minimizeButton.click();
                        window.dispatchEvent(new Event("supsis-minimized"));
                        break;
                    case "open":
                        if (window.supsis && window.supsis.open) {
                            window.supsis.open();
                        }
                        break;
                    case "connected":
                        window.supsis.i.iframeLoading = false;
                        window.dispatchEvent(new Event("supsis-app-connected"));
                        if (window.supsis.i.liveTraffic && document.getElementById("ls-openButton")) break;
                        log("APP CONNECTED");
                        if (!!document.getElementById("ls-trigger")) {
                            if (self.mobileCheck()) {
                                document.getElementById("ls-trigger").style.display = "none";
                                document.getElementById("ls-trigger").style.opacity = "0";
                            } else {
                                document.getElementById("ls-trigger").style.display = "flex";
                                document.getElementById("ls-trigger").style.opacity = "1";
                            }
                        }
                        if (window.supsis.i) {
                            if (!self.mobileCheck() || !self.settings.hideBubbleOnMobile) {
                                document.body.appendChild(window.supsis.i.openButton);
                                setTimeout(() => window.supsis.i.badgeAction(true), 300);
                            }
                            window.supsis.i.connected = true;
                        }

                        if (self.mobileCheck()) {
                            const isSafari = navigator.userAgent.toLowerCase().indexOf("safari") >= 0;
                            self.iframe.contentWindow.postMessage(
                                {
                                    command: "mobile-detected",
                                    payload: {
                                        landscape: window.outerHeight < window.outerWidth,
                                        isSafari,
                                    },
                                },
                                "*"
                            );
                        }
                        window.dispatchEvent(new Event("supsis-loaded"));

                        if (self.settings.kmkAutoDepartmentBind) {
                            let sellerLink =
                                document.querySelector(".sellerTitle a") ||
                                document.querySelector(".other-products-title a");
                            if (sellerLink) {
                                let href = sellerLink.href || "";
                                let department = href.substring(href.lastIndexOf("/") + 1);
                                window.supsis("department", department);
                            }
                        }
                        break;
                    case "removeOpenButton":
                        if (!!document.getElementById("ls-trigger")) {
                            document.getElementById("ls-trigger").style.display = "none";
                            document.getElementById("ls-trigger").style.opacity = "0";
                        }
                        if (!!document.getElementById("ls-openButton"))
                            document.body.removeChild(window.supsis.i.openButton);
                        break;
                    case "settings-updated":
                        log("settings-updated");
                        window.supsis.i.updateSettings(e.data.payload.settings);
                        break;
                    case "report-url":
                        window.supsis.i.iframeLoading = false;
                        self.iframe.contentWindow.postMessage(
                            {
                                command: "current-url",
                                payload: {
                                    url: window.location.href,
                                },
                            },
                            "*"
                        );
                        break;
                    case "report-info":
                        self.iframe.contentWindow.postMessage(
                            {
                                command: "current-info",
                                payload: {
                                    title: window.document.title,
                                    url: location.href,
                                },
                            },
                            "*"
                        );
                        break;
                    case "report-kmk-seller-id":
                        let sellerLink =
                            document.querySelector(".sellerTitle a") ||
                            document.querySelector(".other-products-title a");
                        let href = sellerLink && sellerLink.href ? sellerLink.href : "";
                        let department = href.substring(href.lastIndexOf("/") + 1);
                        let sellerIdFromParam = location.pathname.split("/")[1];
                        sellerIdFromParam =
                            sellerIdFromParam && sellerIdFromParam.length ? sellerIdFromParam : undefined;
                        department = department || sellerIdFromParam;
                        window.supsis("department", department.length ? department : undefined);
                        break;
                    case "wide-visitor-screen":
                        const mobile = window.outerWidth < 950;
                        if (!mobile) {
                            if (e.data.payload) self.container.classList.add("videocall");
                            else self.container.classList.remove("videocall");
                        }
                        log.debug("wide-visitor-screen", { payload: e.data.payload, mobile: mobile });
                        break;
                    case "setWindowSize":
                        window.supsis("setWindowSize", e.data.payload);
                        break;
                    case "badge":
                        self.badgeAction();
                        break;
                    case "badge-clear":
                        localStorage.removeItem("ls-badge");
                        self.badge = 0;
                        self.badgeElem.innerText = "0";
                        if (window.supsis.i.openButton.contains(self.badgeElem))
                            window.supsis.i.openButton.removeChild(self.badgeElem);
                        break;
                    case "createTrigger":
                        if (self.mobileCheck() && self.settings.hideBubbleOnMobile) {
                            return;
                        }
                        window.supsis.i.initTrigger();
                        break;
                    case "execTrigger":
                        window.supsis.i.execTrigger(e.data.payload).catch();
                        break;
                    case "phone-call":
                        window.open("tel:" + e.data.payload.phoneNumber, "_self");
                        break;
                    case "akinon-get-orders":
                        if (window.AKINON_SUPSIS_API) {
                            const sendOrders = (orders) => {
                                self.iframe.contentWindow.postMessage(
                                    {
                                        command: "akinon-get-orders",
                                        payload: {
                                            orders,
                                        },
                                    },
                                    "*"
                                );
                            };
                            window.AKINON_SUPSIS_API.getOrders()
                                .then((orders) => {
                                    sendOrders(orders);
                                })
                                .catch((err) => {
                                    log.error("akinon-get-orders error", err);
                                    sendOrders([]);
                                });
                        } else {
                            // console.error("AKINON_SUPSIS_API not found");
                        }
                        break;
                    case "akinon-get-user-data":
                        const sendPayload = (payload) => {
                            self.iframe.contentWindow.postMessage(
                                {
                                    command: "akinon-get-user-data",
                                    payload,
                                },
                                "*"
                            );
                        };
                        if (window.AKINON_SUPSIS_API) {
                            window.AKINON_SUPSIS_API.getUserData()
                                .then((data) => {
                                    sendPayload(data);
                                })
                                .catch((err) => {
                                    log.error("akinon-get-user-data error", err);
                                    sendPayload(undefined);
                                });
                        } else {
                            // console.error("AKINON_SUPSIS_API not found");
                            sendPayload(undefined);
                        }
                        break;
                    case "get-visitor-id":
                        log("get-visitor-id istendi");
                        // Mesajı iframe'e ilet
                        if (self.iframe && self.iframe.contentWindow) {
                            self.iframe.contentWindow.postMessage(
                                {
                                    command: "get-visitor-id",
                                    payload: {},
                                },
                                "*"
                            );
                        } else {
                            // iframe henüz yüklenmemiş olabilir, doğrudan visitor ID'yi göndererek cevap ver
                            if (
                                window.supsis &&
                                window.supsis.i &&
                                window.supsis.i.visitorData &&
                                window.supsis.i.visitorData.id
                            ) {
                                window.parent.postMessage(
                                    {
                                        command: "set-visitor-id",
                                        payload: {
                                            visitorId: window.supsis.i.visitorData.id,
                                        },
                                    },
                                    "*"
                                );
                                log("Visitor ID doğrudan gönderildi:", window.supsis.i.visitorData.id);
                            }
                        }
                        break;
                    case "visible-window-bg":
                        log("visible-window-bg", e.data.payload);
                        let color1 = self.settings.chatCustomizationSettings.versionV2Theme.colors.headerColorSecond;
                        let color2 = self.settings.chatCustomizationSettings.versionV2Theme.colors.headerTextColor;
                        window.supsis.i.triangleFooter.changeColor(color1, color2);
                        break;
                }
            }
        };
    };
    SupSis.prototype.requireAssets = function () {
        log.debug("requireAssets");
        this.requireCssFile();
        this.requireJsFile();
    };
    SupSis.prototype.requireCssFile = function () {
        const importCSSFile = function (url) {
            log.debug("requireCssFile");
            const link = document.createElement("link");
            link.href = url;
            link.rel = "stylesheet";
            this.head.appendChild(link);
        };
        importCSSFile.call(this, this.cssFile);
        const isAydinli = ["tr.uspoloassn.com", "www.pierrecardin.com.tr", "www.cacharel.com.tr"].includes(
            window.location.host
        );
        if (isAydinli) {
            importCSSFile.call(this, this.akinonCSSFile);
        }
    };
    SupSis.prototype.requireJsFile = function () {
        log.debug("requireJsFile");
        const importJSFile = function (file, id = "supsis-actions") {
            let script = document.createElement("script");
            script.type = "text/javascript";
            script.src = file;
            script.id = id;
            this.body.appendChild(script);
        };
        importJSFile.call(this, this.jsFile);
        if (["tr.uspoloassn.com", "www.pierrecardin.com.tr", "www.cacharel.com.tr"].includes(window.location.host)) {
            importJSFile.call(this, this.akinonJSFile, "akinon-actions");
        }
        try {
            const getTrackId = () => {
                if (window.location.hostname.includes("vatanbilgisayar")) return "fe608272-6916-4081-8fe7-e6ebef9695d0";
                else if (window.location.hostname.includes("themarmarachocolate"))
                    return "52126f27-78b4-4532-98db-6b32587f2fcc";
                else if (window.location.hostname.includes("tayfunaybek"))
                    return "27473814-a2f4-4f95-8fc3-b35651f25526";
                else if (window.location.hostname.includes("etu.edu.tr")) return "f8037c94-f471-4620-a862-dba0adf6f8b7";
                else {
                    if (this.settings.websiteTrackingId)
                        return this.settings.liveAnalytics && this.settings.websiteTrackingId;
                    else return null;
                }
            };
            const trackId = getTrackId();
            if (trackId) {
                {
                    var supsisTrackScript = document.createElement("script");
                    supsisTrackScript.defer = true;
                    supsisTrackScript.src = "https://track.supsis.live/script.js";
                    supsisTrackScript.setAttribute("data-website-id", trackId);

                    document.head.appendChild(supsisTrackScript);
                }
            }
        } catch (e) {
            console.error("Error in requireJsFile", e);
        }
    };

    SupSis.prototype.requireSystem = function () {
        log.debug("requireSystem");
        this.container = document.createElement("div");
        this.container.id = "ls-container";
        this.container.style.display = "none";

        if (this.newVersion) {
            this.container.className = "v2";
            this.container.style.backgroundColor = "transparent";
        }

        if (window.outerWidth < 950) {
            this.container.classList.add("mobile-version");
        }

        if (this.newVersion) {
            this.setupV2();
        } else {
            this.minimizeButton = document.createElement("div");
            this.minimizeButton.id = "ls-minimize-button";
            this.minimizeButton.innerHTML = '<img src="' + this.iconUrls.minimize + '" alt="">';
            this.minimizeButton.title = "Minimize";
            this.container.appendChild(this.minimizeButton);
        }

        this.openButton = document.createElement("div");
        if (this.isHidden) {
            this.openButton.style.visibility = "hidden";
        }
        this.openButton.id = "ls-openButton";
        if (!!siteSettings && !!siteSettings.bubble) {
            let bubble = siteSettings.bubble;
            if (bubble.preDefined === "0" && !!bubble.customIcon) {
                const oldPath = `https://static.supsis.live/${bubble.customIcon.path}${bubble.customIcon.id}.${bubble.customIcon.ext}`;
                this.openButton.innerHTML = `<div style="height:60px;justify-content: flex-end;"><img src="${
                    bubble.customIcon.v2Format && bubble.customIcon.cdnUrl ? bubble.customIcon.cdnUrl : oldPath
                }">
                </div>`;
            } else if (bubble.preDefined !== "0")
                this.openButton.innerHTML = `<div style="height:60px;justify-content: flex-end;">${
                    getBubble(bubble.preDefined, bubble.bubbleColor).img
                }</div>`;
            else this.openButton.innerHTML = '<img src="' + this.baseUrl + 'static/img/newLogo.png"  alt=""/>';
        } else this.openButton.innerHTML = '<img src="' + this.baseUrl + 'static/img/newLogo.png"  alt=""/>';

        this.badgeElem = document.createElement("div");
        this.badgeElem.classList.add("ls-badge");
    };
    SupSis.prototype.iframeLoad = function () {
        log.debug("iframeLoad");

        this.iframe = document.createElement("iframe");
        this.iframe.id = "supsis-iframe";
        this.iframe.style.borderRadius = "8px 8px 0 0";
        this.iframe.style.backgroundColor = "transparent";
        if (this.newVersion) {
            if (["bottomLeft"].includes(this.settings.chatCustomizationSettings.position)) {
                this.iframe.style.borderRadius = "20px 20px 20px 0px";
            } else if (["left"].includes(this.settings.chatCustomizationSettings.position)) {
                this.iframe.style.borderRadius = "20px";
            } else if (["right"].includes(this.settings.chatCustomizationSettings.position)) {
                this.iframe.style.borderRadius = "20px";
            } else {
                this.iframe.style.borderRadius = "20px 20px 0px 20px";
            }
        }

        this.iframe.sandbox =
            "allow-forms allow-top-navigation allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-scripts allow-downloads allow-modals";
        this.iframe.allow = "camera *;microphone *;fullscreen *; geolocation *;display-capture *;";

        this.iframe.frameBorder = "0";
        this.iframe.loading = "eager";
        this.iframe.importance = "high";
        this.container.appendChild(this.iframe);
        log.debug("iframe added to container");
        this.body.appendChild(this.container);
        log.debug("container added to body");
        this.iframe.dispatchEvent(new Event("resize"));
        const self = this;
        const loadContent = () => {
            log.debug("loadContent");
            let src = self.baseUrl.endsWith("/") ? self.baseUrl.slice(0, self.baseUrl.length - 1) : self.baseUrl;
            log("loadContent", { src, baseUrl: self.baseUrl, self, CONFIG });
            self.iframe.src = src;
            if (!document.body.classList.contains("ls-opened")) {
                const el = document.getElementById("ls-container");
                if (el) {
                    el.style.display = "none";
                }
            }
            self.iframe.onload = function () {
                window.supsis.i.iframeLoading = false;
                const el = document.getElementById("ls-iframe-loading");
                if (el) {
                    el.style.display = "none";
                    this.container.style.display = "block";
                }
            };
        };
        let failCount = 0;
        let startContentLoader = (timerInterval) =>
            setTimeout(() => {
                log.debug(`iframe content will load ${timerInterval}`);
                if (failCount > 20) return;
                try {
                    log.debug("iframe height", window.supsis.i.container.getBoundingClientRect().height);
                    window.supsis.i.container.style.display = "block";
                    if (window.supsis.i.container.getBoundingClientRect().height > 0) {
                        loadContent();
                    } else {
                        log.debug(`iframe not viewing on dom`);
                        failCount++;
                        startContentLoader(500);
                    }
                } catch (e) {
                    log.debug(`an error occurred`, e);
                    failCount++;
                    startContentLoader(1000);
                }
            }, timerInterval);
        startContentLoader(1000);
    };
    SupSis.prototype.badgeAction = function (isInit = false) {
        if (!this.isOpen) return;
        if (!!this.isOpen && !this.isOpen() && !isInit) this.badge++;
        localStorage.setItem("ls-badge", this.badge.toString());
        this.badgeElem.innerText = this.badge > 9 ? "9+" : this.badge;
        if (this.badge !== 0 && !window.supsis.i.openButton.contains(this.badgeElem))
            window.supsis.i.openButton.appendChild(this.badgeElem);
    };
    SupSis.prototype.clearBadge = function () {
        localStorage.removeItem("ls-badge");
        this.badge = 0;
        this.badgeElem.innerText = "0";
        if (window.supsis.i.openButton.contains(this.badgeElem)) window.supsis.i.openButton.removeChild(this.badgeElem);
    };
    SupSis.prototype.initTrigger = function () {
        const lsTriggerEl = document.getElementById("ls-trigger");
        log("initTrigger", lsTriggerEl);
        if (!!lsTriggerEl) document.body.removeChild(lsTriggerEl);

        let container = document.createElement("div");
        container.id = "ls-trigger";
        container.style.display = "none";
        relocation(container, true);
        document.body.appendChild(container);
        this.triggerElems.container = container;
        const initTriggerTitle = document.createElement("div");
        initTriggerTitle.classList.add("trigger-title");
        initTriggerTitle.style.color = siteSettings.bubble.bubbleColor;
        initTriggerTitle.style.display = "none";
        container.appendChild(initTriggerTitle);
        this.triggerElems.title = initTriggerTitle;
        let close = document.createElement("div");
        let poweredBy = document.getElementById("PoweredImage");
        if (["bottomRight", "right"].includes(this.settings.chatCustomizationSettings.position)) {
            close.style.left = "-8px";
            close.style.boxShadow = "-13px -10px 22px 0px rgba(0,0,0,0.1)";
        } else {
            close.style.right = "-8px";
            close.style.boxShadow = "13px -10px 22px 0px rgba(0,0,0,0.1)";
        }
        close.id = "ls-trigger-close";
        close.innerText = "x";
        close.addEventListener("mouseover", () => {
            close.style.backgroundColor = siteSettings.bubble.bubbleColor;
        });
        close.addEventListener("mouseleave", () => {
            close.style.backgroundColor = "white";
        });
        close.addEventListener("click", () => {
            container.style.display = "none";
            this.triggerElems.messageContainer.innerHTML = "";
            this.triggerElems.title.innerHTML = "";
        });
        container.appendChild(close);
        this.triggerElems.close = close;
        let messageContainer = document.createElement("div");
        messageContainer.id = "ls-trigger-message-container";
        container.appendChild(messageContainer);
        this.triggerElems.messageContainer = messageContainer;
        log("initTrigger completed", this.triggerElems);
    };
    SupSis.prototype.execTrigger = async function ([
        title,
        msgHTML,
        duration,
        options,
        enabled,
        answers,
        { showHeaderImage },
        { popupTireggers },
    ]) {
        try {
            if (this.isOpen()) return;
            log.info("execTrigger", { msgHTML, duration, title, options, enabled, answers });
            this.triggerElems.question = answers;
            this.triggerElems.showHeaderImage = showHeaderImage;
            this.triggerElems.popupTireggers = popupTireggers;
            if (!enabled) return;
            if (!!this.triggerElems && !!this.triggerElems.container) {
                if (
                    !!this.fabContainer &&
                    !!this.fabContainer.classList &&
                    this.fabContainer.classList.contains("active")
                )
                    this.triggerElems.container.style.opacity = 0;
                this.triggerElems.container.style.display = "flex";
            }
            let messages = [];
            let shadowDOM = document.createElement("div");
            shadowDOM.innerHTML = msgHTML;
            Array.from(shadowDOM.childNodes)
                .filter((x) => (x.textContent || "").length > 0 || x.nodeName === "IMG")
                .forEach((msgEl) => {
                    let message = document.createElement("div");
                    log("trigger msgEl", msgEl);
                    message.append(msgEl);
                    message.classList.add("ls-message");
                    messages.push(message);
                });

            if (Array.isArray(options) && options.length > 0) {
                for (const option of options.map((cmd) => ({ cmd, type: cmd }))) {
                    await new Promise((resolve) => {
                        setTimeout(() => {
                            window.supsis[option.cmd]({ message: msgHTML });
                            resolve();
                        }, duration * 1000);
                    });
                }
            } else {
                for (const message of messages.reverse()) {
                    await new Promise((resolve) => {
                        setTimeout(() => {
                            if (!!this.triggerElems && !!this.triggerElems.messageContainer) {
                                this.triggerElems.messageContainer.appendChild(message);
                            }
                            resolve();
                        }, duration * 1000);
                    });
                    this.triggerElems.title.innerHTML = title;
                    this.triggerElems.title.style.display = "block";
                }
            }
        } catch (e) {
            log.error("execTrigger", e);
        }
    };
    SupSis.prototype.askDialog = function (payload) {
        this.triggerElems.container.style.display = "none";
        this.triggerElems.messageContainer.innerHTML = "";
        if (this.triggerElems.popupTireggers === true) {
            let color = siteSettings.bubble;
            if (!!this.triggerElems.askContainer) document.body.removeChild(this.triggerElems.askContainer);
            this.triggerElems.askContainer = document.createElement("div");

            class supsisModalMask extends HTMLElement {}

            customElements.define("supsis-modal-mask", supsisModalMask);
            const modalMask = document.createElement("supsis-modal-mask");
            modalMask.id = "ls-trigger-dialog-modal-mask";

            class supsisModalContainer extends HTMLElement {}

            customElements.define("supsis-modal-container", supsisModalContainer);
            const messageContainer = document.createElement("supsis-modal-container");
            messageContainer.className = "ls-modal-message-container";
            this.triggerElems.askContainer.id = "ls-trigger-dialog-modal";
            this.triggerElems.askContainer.style.zIndex = "999999999";

            class supsisModalClose extends HTMLElement {}

            customElements.define("supsis-modal-close", supsisModalClose);
            const modalClose = document.createElement("supsis-modal-close");
            modalClose.classList.add("ls-trigger-dialog-modal-close");
            modalClose.innerHTML = "x";
            modalClose.style.backgroundColor = color.bubbleColor;

            class supsisModalInput extends HTMLElement {}

            customElements.define("supsis-modal-input", supsisModalInput);
            const inputGroup = document.createElement("supsis-modal-input");
            inputGroup.className = "ls-modal-input-group";
            const buttonWrapper = document.createElement("div");
            buttonWrapper.className = "ls-modal-button-wrapper";
            const askHeader = document.createElement("div");
            const companyHeaderContainer = document.createElement("div");
            const imageWrapper = document.createElement("div");
            const companyInfoWrapper = document.createElement("div");
            const companyImage = document.createElement("img");
            const companyName = document.createElement("div");
            const companyDesc = document.createElement("p");
            if (siteSettings.organizationLogo && siteSettings.organizationName) {
                askHeader.id = "askHeader";
                askHeader.classList.add("ls-modal-ask-header");
                companyHeaderContainer.classList.add("ls-modal-header-container");
                companyInfoWrapper.classList.add("ls-modal-info-wrapper");
                imageWrapper.classList.add("ls-modal-image-wrapper");
                companyImage.classList.add("ls-modal-company-image");
                companyName.classList.add("ls-modal-company-name");
                companyDesc.classList.add("ls-modal-company-desc");
                const asset = siteSettings.organizationLogo;
                companyImage.src =
                    asset.v2Format && asset.cdnUrl
                        ? asset.cdnUrl
                        : `https://static.supsis.live/${asset.path}${asset.id}.${asset.ext}`;
                companyName.innerHTML = siteSettings.organizationName;
                companyDesc.innerHTML = siteSettings.companySlogan;
                imageWrapper.appendChild(companyImage);
                companyInfoWrapper.appendChild(companyName);
                companyInfoWrapper.appendChild(companyDesc);
                companyHeaderContainer.appendChild(imageWrapper);
                companyHeaderContainer.appendChild(companyInfoWrapper);
                if (this.triggerElems.showHeaderImage === true) {
                    askHeader.appendChild(companyHeaderContainer);
                }
            }
            const yesBtn = document.createElement("button");
            yesBtn.classList.add("ls-modal-yes-btn");
            yesBtn.style.backgroundColor = siteSettings.bubble.bubbleColor;
            let questionObject = {};
            questionObject["tr"] = {
                yesPlease: "Evet lütfen!",
                noThanks: "Hayır, teşekkürler.",
                messageContent: "Bize sormak ister misiniz?",
            };
            questionObject["en"] = {
                yesPlease: "Yes, please!",
                noThanks: "No, thanks.",
                messageContent: "Would you like to ask us?",
            };
            questionObject["ru"] = {
                yesPlease: "Да, пожалуйста!",
                noThanks: "Спасибо, не надо.",
                messageContent: "Хотите спросить нас?",
            };
            questionObject["de"] = {
                yesPlease: "Ja, bitte!",
                noThanks: "Nein, danke.",
                messageContent: "Möchten Sie uns fragen?",
            };
            questionObject["fr"] = {
                yesPlease: "Oui s'il vous plaît!",
                noThanks: "Non merci.",
                messageContent: "Voulez-vous nous demander?",
            };
            questionObject["es"] = {
                yesPlease: "¡Sí por favor!",
                noThanks: "No, gracias.",
                messageContent: "¿Quieres preguntarnos?",
            };
            questionObject["it"] = {
                yesPlease: "Sì per favore!",
                noThanks: "No grazie.",
                messageContent: "Vuoi chiederci?",
            };
            questionObject["de"] = {
                yesPlease: "Ja, bitte!",
                noThanks: "Nein, danke.",
                messageContent: "Möchten Sie uns fragen?",
            };
            questionObject["fr"] = {
                yesPlease: "Oui s'il vous plaît!",
                noThanks: "Non merci.",
                messageContent: "Voulez-vous nous demander?",
            };
            questionObject["es"] = {
                yesPlease: "¡Sí por favor!",
                noThanks: "No, gracias.",
                messageContent: "¿Quieres preguntarnos?",
            };
            questionObject["ar"] = {
                yesPlease: "نعم من فضلك!",
                noThanks: "لا شكرا.",
                messageContent: "هل تريد أن تسألنا؟",
            };
            questionObject["it"] = {
                yesPlease: "Sì per favore!",
                noThanks: "No grazie.",
                messageContent: "Vuoi chiederci?",
            };
            const navigatorLanguage = navigator.language.split("-")[0];
            const visitorLanguage =
                !!this.triggerElems &&
                !!this.triggerElems.question &&
                !!this.triggerElems.question.visitorLanguageSelectionFromCpanel
                    ? this.triggerElems.question.visitorLanguageSelectionFromCpanel
                    : navigatorLanguage;
            messageContainer.innerHTML =
                !payload.message || payload.message === " "
                    ? !!questionObject && !!questionObject[visitorLanguage]
                        ? questionObject[visitorLanguage].messageContent
                        : "Would you like to ask us?"
                    : payload.message;
            const firstAnswer =
                !!this.triggerElems && !!this.triggerElems.question && !!this.triggerElems.question.first
                    ? this.triggerElems.question.first
                    : questionObject[visitorLanguage].yesPlease;
            yesBtn.type = "button";
            yesBtn.innerHTML = `<span>${firstAnswer}</span>`;
            yesBtn.onclick = function () {
                modalMask.style.display = "none";
                this.triggerElems.askContainer.style.display = "none";
                if (siteSettings.customLoginFormEnabled === true && siteSettings.triggerSkipLoginForm === true) {
                    window.supsis.open();
                } else {
                    window.supsis.login({
                        initialMessage: `${firstAnswer}`,
                        loginData: {},
                    });
                    window.supsis.open();
                }
            }.bind(this);
            const noBtn = document.createElement("button");
            const secondAnswer =
                !!this.triggerElems && !!this.triggerElems.question && !!this.triggerElems.question.second
                    ? this.triggerElems.question.second
                    : questionObject[visitorLanguage].noThanks;
            noBtn.type = "button";
            noBtn.classList.add("ls-modal-no-button");
            noBtn.style.border = `1px solid ${siteSettings.bubble.bubbleColor}`;
            noBtn.innerHTML = `<span>${secondAnswer}</span>`;
            noBtn.onclick = function () {
                this.triggerElems.askContainer.classList.add("ls-hide-animation");
                modalMask.style.display = "none";
                setTimeout(
                    function () {
                        this.triggerElems.askContainer.style.display = "none";
                    }.bind(this),
                    500
                );
            }.bind(this);

            modalClose.onclick = function () {
                this.triggerElems.askContainer.classList.add("ls-hide-animation");
                modalMask.style.display = "none";

                setTimeout(
                    function () {
                        this.triggerElems.askContainer.style.display = "none";
                    }.bind(this),
                    500
                );
            }.bind(this);

            modalMask.onclick = function () {
                this.triggerElems.askContainer.classList.add("ls-hide-animation");
                modalMask.style.display = "none";

                setTimeout(
                    function () {
                        this.triggerElems.askContainer.style.display = "none";
                    }.bind(this),
                    500
                );
            }.bind(this);

            document.body.appendChild(this.triggerElems.askContainer);
            this.triggerElems.askContainer.appendChild(modalClose);
            this.triggerElems.askContainer.appendChild(messageContainer);
            messageContainer.appendChild(inputGroup);
            buttonWrapper.appendChild(yesBtn);
            buttonWrapper.appendChild(noBtn);
            inputGroup.appendChild(buttonWrapper);
            this.triggerElems.askContainer.appendChild(askHeader);
            this.triggerElems.askContainer.appendChild(messageContainer);
            this.triggerElems.askContainer.appendChild(inputGroup);
            document.body.appendChild(modalMask);
        } else if (this.triggerElems.popupTireggers === false) {
            this.triggerElems.container.style.display = "none";
            this.triggerElems.messageContainer.innerHTML = "";
            if (!!this.triggerElems.askContainer) document.body.removeChild(this.triggerElems.askContainer);
            this.triggerElems.askContainer = document.createElement("div");
            this.triggerElems.askContainer.id = "ls-trigger-dialog";
            this.triggerElems.askContainer.style.zIndex = "999999999";
            relocation(this.triggerElems.askContainer, true);
            document.body.appendChild(this.triggerElems.askContainer);
            const askHeader = document.createElement("div");
            const companyHeaderContainer = document.createElement("div");
            const imageWrapper = document.createElement("div");
            const companyInfoWrapper = document.createElement("div");
            const companyImage = document.createElement("img");
            const companyName = document.createElement("div");
            const companyDesc = document.createElement("p");
            if (siteSettings.organizationLogo && siteSettings.organizationName) {
                askHeader.id = "askHeader";
                askHeader.classList.add("ask-header");
                companyHeaderContainer.classList.add("header-container");
                companyInfoWrapper.classList.add("info-wrapper");
                imageWrapper.classList.add("image-wrapper");
                companyImage.classList.add("company-image");
                companyName.classList.add("company-name");
                companyDesc.classList.add("company-desc");
                const asset = siteSettings.organizationLogo;
                companyImage.src =
                    asset.v2Format && asset.cdnUrl
                        ? asset.cdnUrl
                        : `https://static.supsis.live/${asset.path}${asset.id}.${asset.ext}`;
                companyName.innerHTML = siteSettings.organizationName;
                companyDesc.innerHTML = siteSettings.companySlogan;
                imageWrapper.appendChild(companyImage);
                companyInfoWrapper.appendChild(companyName);
                companyInfoWrapper.appendChild(companyDesc);
                companyHeaderContainer.appendChild(imageWrapper);
                companyHeaderContainer.appendChild(companyInfoWrapper);
                if (this.triggerElems.showHeaderImage === true) {
                    askHeader.appendChild(companyHeaderContainer);
                }
            }
            const messageContainer = document.createElement("div");
            messageContainer.className = "message-container";
            const inputGroup = document.createElement("div");
            inputGroup.className = "input-group";
            const buttonWrapper = document.createElement("div");
            buttonWrapper.className = "button-wrapper";
            const yesBtn = document.createElement("button");
            yesBtn.classList.add("yes-button");
            yesBtn.style.backgroundColor = siteSettings.bubble.bubbleColor;
            let questionObject = {};
            questionObject["tr"] = {
                yesPlease: "Evet lütfen!",
                noThanks: "Hayır, teşekkürler.",
                messageContent: "Bize sormak ister misiniz?",
            };
            questionObject["en"] = {
                yesPlease: "Yes, please!",
                noThanks: "No, thanks.",
                messageContent: "Would you like to ask us?",
            };
            questionObject["ru"] = {
                yesPlease: "Да, пожалуйста!",
                noThanks: "Спасибо, не надо.",
                messageContent: "Хотите спросить нас?",
            };
            questionObject["de"] = {
                yesPlease: "Ja, bitte!",
                noThanks: "Nein, danke.",
                messageContent: "Möchten Sie uns fragen?",
            };
            questionObject["fr"] = {
                yesPlease: "Oui s'il vous plaît!",
                noThanks: "Non merci.",
                messageContent: "Voulez-vous nous demander?",
            };
            questionObject["es"] = {
                yesPlease: "¡Sí por favor!",
                noThanks: "No, gracias.",
                messageContent: "¿Quieres preguntarnos?",
            };
            questionObject["it"] = {
                yesPlease: "Sì per favore!",
                noThanks: "No grazie.",
                messageContent: "Vuoi chiederci?",
            };
            questionObject["de"] = {
                yesPlease: "Ja, bitte!",
                noThanks: "Nein, danke.",
                messageContent: "Möchten Sie uns fragen?",
            };
            questionObject["fr"] = {
                yesPlease: "Oui s'il vous plaît!",
                noThanks: "Non merci.",
                messageContent: "Voulez-vous nous demander?",
            };
            questionObject["es"] = {
                yesPlease: "¡Sí por favor!",
                noThanks: "No, gracias.",
                messageContent: "¿Quieres preguntarnos?",
            };
            questionObject["ar"] = {
                yesPlease: "نعم من فضلك!",
                noThanks: "لا شكرا.",
                messageContent: "هل تريد أن تسألنا؟",
            };
            questionObject["it"] = {
                yesPlease: "Sì per favore!",
                noThanks: "No grazie.",
                messageContent: "Vuoi chiederci?",
            };
            const navigatorLanguage = navigator.language.split("-")[0];
            const visitorLanguage =
                !!this.triggerElems &&
                !!this.triggerElems.question &&
                !!this.triggerElems.question.visitorLanguageSelectionFromCpanel
                    ? this.triggerElems.question.visitorLanguageSelectionFromCpanel
                    : navigatorLanguage;
            messageContainer.innerHTML =
                !payload.message || payload.message === " "
                    ? !!questionObject && !!questionObject[visitorLanguage]
                        ? questionObject[visitorLanguage].messageContent
                        : "Would you like to ask us?"
                    : payload.message;
            const firstAnswer =
                !!this.triggerElems && !!this.triggerElems.question && !!this.triggerElems.question.first
                    ? this.triggerElems.question.first
                    : questionObject[visitorLanguage].yesPlease;
            yesBtn.type = "button";
            yesBtn.innerHTML = `<span>${firstAnswer}</span>`;
            yesBtn.onclick = function () {
                this.triggerElems.askContainer.style.display = "none";
                if (siteSettings.customLoginFormEnabled === true && siteSettings.triggerSkipLoginForm === true) {
                    window.supsis.open();
                } else {
                    log.debug("siteSettings", siteSettings);
                    window.supsis.login({
                        initialMessage: `${firstAnswer}`,
                        loginData: {},
                    });
                    window.supsis.open();
                }
            }.bind(this);
            const noBtn = document.createElement("button");
            const secondAnswer =
                !!this.triggerElems && !!this.triggerElems.question && !!this.triggerElems.question.second
                    ? this.triggerElems.question.second
                    : questionObject[visitorLanguage].noThanks;
            noBtn.type = "button";
            noBtn.classList.add("no-button");
            noBtn.innerHTML = `<span>${secondAnswer}</span>`;
            noBtn.onclick = function () {
                this.triggerElems.askContainer.style.display = "none";
            }.bind(this);
            buttonWrapper.appendChild(yesBtn);
            buttonWrapper.appendChild(noBtn);
            inputGroup.appendChild(buttonWrapper);
            this.triggerElems.askContainer.appendChild(askHeader);
            this.triggerElems.askContainer.appendChild(messageContainer);
            this.triggerElems.askContainer.appendChild(inputGroup);
        }
    };
    SupSis.prototype.fab = function (_instance) {
        class supsisFabList extends HTMLElement {}

        customElements.define("supsis-fab-list", supsisFabList);

        class supsisFabItem extends HTMLElement {}

        customElements.define("supsis-fab-item", supsisFabItem);

        class supsisParagraph extends HTMLElement {}

        customElements.define("supsis-paragraph", supsisParagraph);

        log("fab");
        if (!this.settings) return;
        this.fabContainer = document.createElement("supsis-fab-list");
        this.fabContainer.id = "ls-fab";
        if (this.settings.fab.isAlwaysActive && window.outerWidth > 950) {
            this.fabContainer.classList.add("active");
        }
        const instance = window.supsis.i || _instance;
        const mobileCheck = function () {
            let check = false;
            (function (a) {
                if (
                    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                        a
                    ) ||
                    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                        a.substring(0, 4)
                    )
                )
                    check = true;
            })(navigator.userAgent || navigator.vendor || window.opera);
            return check;
        };
        if (mobileCheck() && this.showFab) {
            this.fabContainer.style.display = "grid";
        } else {
            this.fabContainer.style.display = "flex";
        }

        const gap =
            !!instance.settings.bubble && instance.settings.bubble.heightOfBubble
                ? instance.settings.bubble.heightOfBubble
                : "60";
        if (["bottomRight", "right"].includes(this.settings.chatCustomizationSettings.position)) {
            this.fabContainer.style.right = parseInt(instance.openButton.style.right.slice(0, -2)) + "px";
        } else {
            this.fabContainer.style.left = parseInt(instance.openButton.style.left.slice(0, -2)) + "px";
        }
        this.fabContainer.style.bottom = parseInt(instance.openButton.style.bottom.slice(0, -2)) + parseInt(gap) + "px";

        const openFn = () => {
            if (mobileCheck() && !this.showFab) {
                this.fabContainer.style.display = "grid";
            } else {
                this.fabContainer.style.display = "flex";
            }
            if (!!this.triggerElems && !!this.triggerElems.container) {
                this.triggerElems.container.style.display = "none";
                const askContainer = this.triggerElems.askContainer;
                const modalMask = document.getElementById("ls-trigger-dialog-modal-mask");
                if (askContainer) {
                    askContainer.style.display = "none";
                }
                if (this.triggerElems && this.triggerElems.container) {
                    this.triggerElems.container.style.display = "none";
                }
            }
            this.fabContainer.classList.add("active");
        };
        const closeFn = () => {
            setTimeout(() => {
                if (!this.showFab) {
                    if (!!this.triggerElems && !!this.triggerElems.container)
                        this.triggerElems.container.style.display = "flex";
                    this.fabContainer.classList.remove("active");
                }
            }, 300);
        };
        const mouseOverCallback = () => {
            let el = document.getElementById("ls-fab");
            if (el) {
                el.classList.add("active");
                console.log("mouseOverCallback");
            }
        };
        const clickCallback = () => {
            let el = document.getElementById("ls-trigger");
            if (el) {
                el.remove();
            }
        };
        const close = document.createElement("div");
        close.addEventListener("click", closeFn);
        close.id = "ls-fab-close";
        close.innerText = "x";

        if (mobileCheck()) {
            this.fabContainer.appendChild(close);
            this.openButton.addEventListener("click", () => {
                openFn();
                this.showFab = true;
                setTimeout(() => {
                    this.showFab = false;
                }, 500);
            });
        } else {
            this.fabContainer.addEventListener("mouseover", () => {
                this.showFab = true;
            });
            this.fabContainer.addEventListener("mouseleave", () => {
                this.showFab = false;
                closeFn();
            });

            this.openButton.addEventListener("mouseover", openFn);
            this.openButton.addEventListener("mouseleave", closeFn);
            this.openButton.addEventListener("mouseover", mouseOverCallback);
            this.openButton.addEventListener("click", clickCallback);
            let el = document.getElementById("ls-fab");
        }

        document.body.appendChild(this.fabContainer);

        let fabs = this.settings.fab.items;
        let enabledFabs = fabs.filter((x) => x.enable === true);
        let showedFabs = enabledFabs.filter((enable) => {
            if (enable.type === "whatsapp") {
                return enable.path !== "" && enable.text !== "";
            } else if (enable.type === "phone") {
                return enable.tel !== "";
            } else if (enable.type === "email") {
                return enable.mail !== "" && enable.text !== "";
            } else if (
                enable.type === "facebook" ||
                enable.type === "twitter" ||
                enable.type === "instagram" ||
                enable.type === "youtube" ||
                enable.type === "linkedin" ||
                enable.type === "telegram"
            ) {
                return enable.path !== "";
            } else return !!enable;
        });

        let isFabAsText =
            !!this.settings && !!this.settings.fab && !!this.settings.fab.isFabsAsIcon
                ? this.settings.fab.isFabsAsIcon
                : false;
        let fabIconsSources = {
            live: `${this.baseUrl}static/img/liveIcon.svg`,
            whatsapp: `${this.baseUrl}static/img/whatsappIcon.svg`,
            ticket: `${this.baseUrl}static/img/ticketIcon.svg`,
            phone: `${this.baseUrl}static/img/phoneIcon.svg`,
            email: `${this.baseUrl}static/img/newMailIcon.svg`,
            facebook: `${this.baseUrl}static/img/facebookIcon.svg`,
            twitter: `${this.baseUrl}static/img/twitterIcon.svg`,
            instagram: `${this.baseUrl}static/img/instagramIcon.svg`,
            youtube: `${this.baseUrl}static/img/youtubeIcon.svg`,
            linkedin: `${this.baseUrl}static/img/linkedinIcon.svg`,
            telegram: `${this.baseUrl}static/img/telegramIcon.svg`,
        };

        let titleDict = {};
        titleDict["tr"] = {
            live: "Canlı Destek",
            whatsapp: "WhatsApp",
            ticket: "Talep Gönder", // Güncellendi
            phone: "Telefon",
            email: "E-posta",
            facebook: "Facebook",
            twitter: "Twitter",
            instagram: "Instagram",
            youtube: "Youtube",
            linkedin: "Linkedin",
            telegram: "Telegram",
        };
        titleDict["en"] = {
            live: "Live Support",
            whatsapp: "WhatsApp",
            ticket: "Submit Request", // Güncellendi
            phone: "Phone",
            email: "E-mail",
            facebook: "Facebook",
            twitter: "Twitter",
            instagram: "Instagram",
            youtube: "Youtube",
            linkedin: "LinkedIn",
            telegram: "Telegram",
        };
        titleDict["ru"] = {
            live: "Онлайн поддержка",
            whatsapp: "WhatsApp",
            ticket: "Отправить запрос", // Güncellendi
            phone: "Телефон",
            email: "Эл. адрес",
            facebook: "Фейсбук",
            twitter: "Твиттер",
            instagram: "Инстаграм",
            youtube: "YouTube",
            linkedin: "LinkedIn",
            telegram: "Telegram",
        };
        titleDict["de"] = {
            live: "Live-Support",
            whatsapp: "WhatsApp",
            ticket: "Anfrage senden", // Güncellendi
            phone: "Telefon",
            email: "E-Mail",
            facebook: "Facebook",
            twitter: "Twitter",
            instagram: "Instagram",
            youtube: "Youtube",
            linkedin: "LinkedIn",
            telegram: "Telegram",
        };
        titleDict["fr"] = {
            live: "Support en direct",
            whatsapp: "WhatsApp",
            ticket: "Envoyer une demande", // Güncellendi
            phone: "Téléphone",
            email: "E-mail",
            facebook: "Facebook",
            twitter: "Twitter",
            instagram: "Instagram",
            youtube: "Youtube",
            linkedin: "LinkedIn",
            telegram: "Telegram",
        };
        titleDict["es"] = {
            live: "Soporte en vivo",
            whatsapp: "WhatsApp",
            ticket: "Enviar solicitud", // Güncellendi
            phone: "Teléfono",
            email: "Correo electrónico",
            facebook: "Facebook",
            twitter: "Twitter",
            instagram: "Instagram",
            youtube: "Youtube",
            linkedin: "LinkedIn",
            telegram: "Telegram",
        };
        titleDict["ar"] = {
            live: "الدعم الفني",
            whatsapp: "WhatsApp",
            ticket: "إرسال طلب", // Güncellendi
            phone: "هاتف",
            email: "البريد الإلكتروني",
            facebook: "Facebook",
            twitter: "Twitter",
            instagram: "Instagram",
            youtube: "Youtube",
            linkedin: "LinkedIn",
            telegram: "Telegram",
        };
        titleDict["it"] = {
            live: "Supporto live",
            whatsapp: "WhatsApp",
            ticket: "Invia richiesta", // Güncellendi
            phone: "Telefono",
            email: "E-mail",
            facebook: "Facebook",
            twitter: "Twitter",
            instagram: "Instagram",
            youtube: "Youtube",
            linkedin: "LinkedIn",
            telegram: "Telegram",
        };

        if (!!fabs && fabs.length > 0) {
            for (const fab of showedFabs) {
                let fabEl = document.createElement("supsis-fab-item");
                fabEl.className = "fab-item";
                fabEl.style.backgroundColor = "red";
                let linkEl = document.createElement("a");
                log("fab", fab);
                if (fab.type === "whatsapp" && !!fab.path && !!fab.text && !!fab.callingCode) {
                    fabEl.style.backgroundColor = "#80BA6B";
                    let path = "+" + fab.callingCode + fab.path;
                    if (!!path) {
                        linkEl.href =
                            fab.url +
                            (path || "").replaceAll(/[\(\) ]+/gm, "") +
                            "?text=" +
                            encodeURIComponent(fab.text);
                        linkEl.target = "_blank";
                    }
                } else if (fab.type === "email" && !!fab.text) {
                    if (!!fab.mail) {
                        linkEl.href =
                            "mailto:" +
                            (fab.mail || "").replaceAll(/[\(\) ]+/gm, "") +
                            "?subject=no subject&body=" +
                            encodeURIComponent(fab.text);
                        linkEl.target = "_blank";
                        fabEl.style.backgroundColor = "#FBBC05";
                    }
                } else if (fab.type === "facebook" && !!fab.path) {
                    if (!fab.path.includes("facebook.com")) {
                        fab.path = "https://www.facebook.com/" + fab.path;
                        fabEl.style.backgroundColor = "#5065A8";
                    }
                    linkEl.href = (fab.path || "").replaceAll(/[\(\) ]+/gm, "");
                    linkEl.target = "_blank";
                } else if (fab.type === "twitter" && fab.path) {
                    if (!fab.path.includes("twitter.com")) {
                        fab.path = "https://twitter.com/" + fab.path;
                        fabEl.style.backgroundColor = "#5a9fcb";
                    }
                    linkEl.href = (fab.path || "").replaceAll(/[\(\) ]+/gm, "");
                    linkEl.target = "_blank";
                } else if (fab.type === "instagram" && fab.path) {
                    if (!fab.path.includes("instagram.com")) {
                        fab.path = "https://www.instagram.com/" + fab.path;
                        fabEl.style.backgroundColor = "linear-gradient(90deg, #F9B035 0%, #F98C4E 53%, #CC4A89 100%)";
                    }
                    linkEl.href = (fab.path || "").replaceAll(/[\(\) ]+/gm, "");
                    linkEl.target = "_blank";
                } else if (fab.type === "youtube" && fab.path) {
                    if (!fab.path.includes("youtube.com")) {
                        fab.path = "https://www.youtube.com/c/" + fab.path;
                        fabEl.style.backgroundColor = "#c03020";
                    }
                    linkEl.href = (fab.path || "").replaceAll(/[\(\) ]+/gm, "");
                    linkEl.target = "_blank";
                } else if (fab.type === "linkedin" && fab.path) {
                    if (!fab.path.includes("linkedin.com")) {
                        fab.path = "https://www.linkedin.com/company/" + fab.path;
                        fabEl.style.backgroundColor = "#0077b5";
                    }
                    linkEl.href = (fab.path || "").replaceAll(/[\(\) ]+/gm, "");
                    linkEl.target = "_blank";
                } else if (fab.type === "telegram" && fab.path) {
                    if (!fab.path.includes("t.me")) {
                        fab.path = "https://t.me/" + fab.path;
                        fabEl.style.backgroundColor = "linear-gradient(90deg, #3db2eb 0%, #318cdc 53%, #318cdc 100%)";
                    }
                    linkEl.href = (fab.path || "").replaceAll(/[\(\) ]+/gm, "");
                    linkEl.target = "_blank";
                } else if (fab.type === "phone" && !!fab.tel && !!fab.callingCode) {
                    let telPath = "+" + fab.callingCode + fab.tel;
                    if (!!telPath) {
                        linkEl.href = "tel://" + (telPath || "").replaceAll(/[\(\) ]+/gm, "");
                        linkEl.target = "_blank";
                        fabEl.style.backgroundColor = "#6796FF";
                    }
                } else if (fab.type === "live") {
                    fabEl.style.backgroundColor = "#EC4B1D";
                    linkEl.addEventListener("click", () => {
                        window.supsis.open({ initWithLive: true });
                    });
                } else if (fab.type === "ticket") {
                    fabEl.style.backgroundColor = "#15225C";
                    linkEl.addEventListener("click", () => {
                        window.supsis.open({ initWithTickets: true });
                    });
                }
                if (isFabAsText) {
                    let pFab = document.createElement("supsis-paragraph");
                    pFab.className = "supsis-p-group-text";
                    pFab.innerHTML = titleDict[navigator.language.split("-")[0]][fab.type];
                    linkEl.append(pFab);
                }

                let img = document.createElement("img");
                switch (fab.type) {
                    case "live":
                        img.src = fabIconsSources.live;
                        fabEl.style.backgroundColor = "#EC4B1D";
                        break;
                    case "whatsapp":
                        img.src = fabIconsSources.whatsapp;
                        fabEl.style.backgroundColor = "#80BA6B";
                        break;
                    case "ticket":
                        img.src = fabIconsSources.ticket;
                        fabEl.style.backgroundColor = "#15225C";
                        break;
                    case "phone":
                        img.src = fabIconsSources.phone;
                        fabEl.style.backgroundColor = "#6796FF";
                        break;
                    case "email":
                        img.src = fabIconsSources.email;
                        fabEl.style.backgroundColor = "#FBBC05";
                        break;
                    case "facebook":
                        img.src = fabIconsSources.facebook;
                        fabEl.style.backgroundColor = "#5065A8";
                        break;
                    case "twitter":
                        img.src = fabIconsSources.twitter;
                        fabEl.style.backgroundColor = "#5a9fcb";
                        break;
                    case "instagram":
                        img.src = fabIconsSources.instagram;
                        fabEl.style.background = "linear-gradient(90deg, #F9B035 0%, #F98C4E 53%, #CC4A89 100%)";
                        break;
                    case "youtube":
                        img.src = fabIconsSources.youtube;
                        fabEl.style.backgroundColor = "#c03020";
                        break;
                    case "linkedin":
                        img.src = fabIconsSources.linkedin;
                        fabEl.style.backgroundColor = "#0077b5";
                        break;
                    case "telegram":
                        img.src = fabIconsSources.telegram;
                        fabEl.style.background = "linear-gradient(90deg, #3db2eb 0%, #318cdc 53%, #318cdc 100%)";
                        break;
                }
                linkEl.append(img);

                fabEl.appendChild(linkEl);
                if (!!this.fabContainer) this.fabContainer.appendChild(fabEl);
            }
        }
    };
}

if (isInitializedBefore || window.supsisLoadingStarted === true) {
    log.error("SUPSIS is initialized before. Please remove duplicated sdk scripts");
} else {
    onTabVisible().then(() => {
        const isAydinliWebPage = ["cacharel", "pierrecardin", "uspoloassn"].some((x) =>
            window.location.href.includes(x)
        );
        const isCheckoutPage = window.location.href.includes("checkout");
        const isDisabledWebsite = isAydinliWebPage && isCheckoutPage;
        if (!isDisabledWebsite) {
            start();
        }
    });
}

function relocation(container, isDialog = false) {
    const instance = window.supsis.i;
    const gap =
        !!instance.settings.bubble && instance.settings.bubble.heightOfBubble
            ? instance.settings.bubble.heightOfBubble
            : "60";

    if (isDialog) {
        container.style.right = parseInt(instance.openButton.style.right.slice(0, -2)) + 22 + "px";
    } else container.style.right = instance.openButton.style.right;

    if (isDialog) {
        container.style.left = parseInt(instance.openButton.style.left.slice(0, -2)) + "px";
    } else container.style.left = instance.openButton.style.left;

    if (instance.openButton.style.bottom.length <= 0) {
        container.style.bottom = "";
    } else if (!isDialog) {
        container.style.bottom = parseInt(instance.openButton.style.bottom.slice(0, -2)) + parseInt(gap) + 20 + "px";
    } else {
        container.style.bottom = parseInt(instance.openButton.style.bottom.slice(0, -2)) + 22 + "px";
    }

    container.style.top =
        instance.openButton.style.top.length > 0
            ? parseInt(instance.openButton.style.top.slice(0, -2)) + parseInt(gap) + "px"
            : "";
}



//////////////////
// WEBPACK FOOTER
// ./static/scripts.js
// module id = null
// module chunks = 